// MindMate frontend - BackgroundFilterOverlay.js
import React from 'react';
import './BackgroundFilterOverlay.css'; 

const BackgroundFilterOverlay = () => {
  return <div className="background-filter-overlay" />;
};

export default BackgroundFilterOverlay;
